module.exports = __webpack_public_path__ + "img/energy.481a56c5.svg";